module.exports = __webpack_public_path__ + "static/media/24.f0223828.jpg";